import Skeleton from "react-loading-skeleton";
import "./styles.scss";

const DetailCardSkeleton = ({ containerStyle = {} }) => {
  return (
    <div
      className="detail-card-skeleton-container"
      style={{ ...containerStyle }}
    >
      <div className="card-skeleton-inner">
        <Skeleton
          count={8}
          height={12}
          baseColor="#FFFFFF"
          highlightColor="#E3E8EF"
          className="card-skeleton-lines"
        />
      </div>
    </div>
  );
};

export default DetailCardSkeleton;
